
<mat-tab-group mat-align-tabs="center">
    <mat-tab label="{{ 'admin.management' | translate}}"><app-gestion></app-gestion></mat-tab>
    <mat-tab label="{{'admin.extractions' | translate}}"><app-extraction></app-extraction></mat-tab>
    <mat-tab label="{{'admin.users' | translate}}"><app-users></app-users></mat-tab>
    <mat-tab label="{{'admin.reliability' | translate}}"><app-rates></app-rates></mat-tab>
    <!-- Disabled for now -- And need translation
        <mat-tab label="Pannes Stats"><app-breakdown-stats></app-breakdown-stats></mat-tab>
    -->
    <mat-tab label="{{'admin.tree' | translate}}"><app-arbre-management></app-arbre-management></mat-tab>
    <mat-tab label="{{'admin.graphics' | translate}}"><app-power-bi></app-power-bi></mat-tab>
</mat-tab-group>








